import React from 'react';
import { Show, SimpleShowLayout, TextField, useRecordContext } from 'react-admin';
import { CoverImageField } from '../fields/CoverImageField';
import { AudioPreviewField } from '../fields/AudioPreviewField';

// Function to format seconds to time format (MM:SS or HH:MM:SS)
const formatDuration = (seconds: number | string | null | undefined): string => {
  if (!seconds && seconds !== 0) {
    return '-';
  }
  
  const totalSeconds = typeof seconds === 'string' ? parseInt(seconds, 10) : seconds;
  
  if (isNaN(totalSeconds) || totalSeconds < 0) {
    return '-';
  }
  
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const secs = totalSeconds % 60;
  
  if (hours > 0) {
    // Format: HH:MM:SS
    return `${hours}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  } else {
    // Format: MM:SS
    return `${minutes}:${String(secs).padStart(2, '0')}`;
  }
};

const DurationField = ({ source, label }: { source: string; label?: string }) => {
  const record = useRecordContext();
  const duration = record?.[source];
  const formatted = formatDuration(duration);
  
  return (
    <TextField 
      source={source} 
      label={label || 'Duration'}
      record={{ ...record, [source]: formatted }}
    />
  );
};

export const ContentShow = () => (
    <Show title="Audio content details">
      <SimpleShowLayout>
      <TextField source="title" label="Name" />
      <TextField source="description" label="Description" />
      <TextField source="type" label="Content Type" />
      <TextField source="category_name" label="Category" />
      <DurationField source="duration_seconds" label="Duration" />
      <CoverImageField source="id" label="Cover Image" />
      <AudioPreviewField source="id" label="Audio Preview" />
      </SimpleShowLayout>
    </Show>
);

